class ViewState {
    static LIST = 0b0;
    static VIEW = 0b1;
    static EDIT = 0b10;
    static CREATE = 0b100;
    static QUERY = 0b1000;
    static COPY = 0b10000;
    
    static READONLY = 0b1000000000000000;

    static getViewMode(state) {
        state = state & 0b111111111111111;
        switch (state) {
            case ViewState.LIST: return 'list';
            default:
            case ViewState.VIEW: return 'view';
            case ViewState.EDIT: return 'edit';
            case ViewState.CREATE: return 'create';
            case ViewState.QUERY: return 'query';
            case ViewState.COPY: return 'copy';
        }
    }

    static isReadonly(state) {
        return (state & ViewState.READONLY) == ViewState.READONLY;
    }
}

export default ViewState;